"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRowActions = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("@nextui-org/react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var remove_category_1 = require("../../../../../../../api/calls/product/category/remove_category");
var main_1 = require("../../../../../../../reducers/slices/main");
var get_category_thunk_1 = require("../../../../../../../reducers/slices/products/categories/thunks/get_category_thunk");
var category_1 = require("../../../../../../../reducers/slices/categories/category");
var add_category_1 = __importDefault(require("../../product_details/add_category"));
var useRowActions = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_redux_1.useSelector)(function (state) { return state.categoryState; }), categories = _a.categories, pagination = _a.pagination, selectedCategoriesIDs = _a.selectedCategoriesIDs;
    var onSelectionChange = function (keys) {
        if (keys === "all") {
            dispatch((0, category_1.setSelectedCategoriesIDs)(keys));
            return;
        }
        var resultKeys = new Set(keys);
        var currentKeys = selectedCategoriesIDs === "all" ? new Set(categories.map(function (item) { return String(item._id); })) : selectedCategoriesIDs;
        currentKeys.forEach(function (key) {
            if (!categories.some(function (item) { return String(item._id) === key; })) {
                resultKeys.add(key);
            }
        });
        dispatch((0, category_1.setSelectedCategoriesIDs)(resultKeys));
    };
    var rowActions = function (cellValue) {
        return [
            {
                element: ((0, jsx_runtime_1.jsx)(react_2.Tooltip, __assign({ className: "text-foreground", content: "Edit" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { onClick: function () {
                            dispatch((0, main_1.setContentModal)({
                                title: "Edit Product Category",
                                content: (0, jsx_runtime_1.jsx)(add_category_1.default, { category: cellValue, isEditing: true }),
                            }));
                        }, className: "cursor-pointer text-default-400", height: 18, icon: pro_solid_svg_icons_1.faEdit, width: 18 }) }))),
                key: "edit",
            },
            {
                element: ((0, jsx_runtime_1.jsx)(react_2.Tooltip, __assign({ className: "text-foreground", content: "Delete" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { onClick: function () { return onDelete(cellValue); }, className: "cursor-pointer text-default-400", height: 18, icon: pro_solid_svg_icons_1.faTrash, width: 18 }) }))),
                key: "delete",
            },
        ].filter(Boolean);
    };
    var onDelete = function (data) {
        dispatch((0, main_1.setContentModal)({
            title: "Confirm deletion of ".concat(data === null || data === void 0 ? void 0 : data.name, " category"),
            content: ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex pt-4 gap-4" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Are you sure you want to delete this category?", textColor: "text-inputText" }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: "Cancel", size: "small", backgroundColor: "bg-slate-300", textColor: "text-dark", onClick: function () { return dispatch((0, main_1.setContentModal)(null)); } }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: "Continue", size: "small", onClick: function () {
                            (0, remove_category_1.remove_product_category)({
                                _id: data === null || data === void 0 ? void 0 : data._id,
                            }).then(function (response) {
                                if (response.success) {
                                    dispatch((0, main_1.setMessageModal)({ title: "Success...", messages: [response.message] }));
                                    dispatch((0, main_1.setContentModal)(null));
                                    dispatch((0, get_category_thunk_1.get_category_thunk)(__assign({}, pagination)));
                                }
                                else {
                                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong when deleting the category!", messages: [response.message] }));
                                }
                            });
                        } })] }))),
        }));
    };
    return (0, react_1.useMemo)(function () { return ({ rowActions: rowActions, onSelectionChange: onSelectionChange }); }, [rowActions]);
};
exports.useRowActions = useRowActions;
